<div class="user-quick-switch-sheet">
  <!-- Drag Handle (M3 pattern) -->
  <div class="sheet-handle" aria-hidden="true"></div>

  <!-- Header -->
  <div class="sheet-header">
    <h2 class="sheet-title" i18n="@@home.userQuickSwitch.title">ユーザーを切り替え</h2>
    <button mat-icon-button
            class="sheet-close"
            (click)="close()"
            i18n-aria-label="@@common.button.close"
            aria-label="閉じる">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Search Box -->
  <div class="search-box">
    <mat-icon class="search-icon">search</mat-icon>
    <input type="text"
           class="search-input"
           placeholder="ユーザーを検索..."
           [value]="searchQuery()"
           (input)="onSearchInput($event)"
           aria-label="ユーザーを検索"
           i18n-placeholder="@@home.userQuickSwitch.searchPlaceholder" />
  </div>

  <!-- User List -->
  <div class="user-list" role="listbox" aria-label="ユーザー一覧">
    @if (filteredUsers().length === 0) {
      <div class="empty-message">
        @if (searchQuery()) {
          <span i18n="@@home.userQuickSwitch.noMatch">一致するユーザーが見つかりません</span>
        } @else {
          <span i18n="@@home.userQuickSwitch.noUsers">他のユーザーはいません</span>
        }
      </div>
    } @else {
      @for (user of filteredUsers(); track user.id) {
        <button class="user-item"
                role="option"
                (click)="selectUser(user)">
          <span class="user-avatar"
                [class.avatar-male]="user.sex === 'male'"
                [class.avatar-female]="user.sex === 'female'">
            {{ getInitials(user.name) }}
          </span>
          <span class="user-name">{{ user.name }}</span>
        </button>
      }
    }
  </div>
</div>
